import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { GeneralDetails } from './components/GeneralDetails'
import { AccordionCard } from 'components/AccordionCard'
import { usePositionDetailContextValue } from './context/PositionDetailProvider'
import { Requirements } from './components/Requirements'
import { PendingApprovals } from './components/PendingApprovals'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'

const PositionDetailHeader = () => {
  const { state, actions } = usePositionDetailContextValue()

  return (
    <Header
      title={`${state.name} (${state.id})`}
      subTitle="Position Detail"
      rightContent={
        <Flex
          alignItems="center"
          gap={2}
          data-context-key="position_id"
          data-context-value={state.id}
          data-context-label={state.name}
        >
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
        </Flex>
      }
    />
  )
}

const PositionDescription = () => {
  const {
    state: { about },
  } = usePositionDetailContextValue()
  return (
    <AccordionCard
      title="Description"
      size="large"
      defaultOpen={false}
      isAccordion
    >
      <Text>{about}</Text>
    </AccordionCard>
  )
}

export const PositionDetailMain = () => {
  return (
    <>
      <PositionDetailHeader />
      <Box margin={3}>
        <GeneralDetails />
        <br />
        <PositionDescription />
        <br />
        <Requirements />
        <br />
        <PendingApprovals />
      </Box>
    </>
  )
}
